// libs
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';

// redux selectors
import {
  getColorOptions,
  getDefaultColor,
  getDeliveryDetails,
  getDisclaimerText,
  getProductData,
  getProductDiscountPrice,
  getProductId,
  getProductParentSKU,
  getProductPrice,
  getProductSizeOptions,
  getProductSubTitle,
  getProductTitle,
  getReponsibleTagsAvailable,
  getReviewSummary,
  getSizeGuideURL,
  getTagTitles,
  isOneSize,
  isReturnable as _isReturnable,
  isVideoAvailableOnPDP,
  getProductDiscount,
  getCategoryLevel,
  getSelectedSizeName,
  getSelectedSKUID,
  getBadge,
  getUrgencyNudge,
  hasViewSimilar,
  getSelectedSKUDataPDPSections,
  getHeroImageData,
  getModelWidgetData,
  getIsSizeGuideDataAvailable,
  getBrandBook,
} from 'shared/store/details/selectors';
import { getRemoteConfig } from 'shared/store/remoteConfigs/selectors';

// component
import Analytics from './Analytics';
import { DEFAULT_CURRENCY_CODE } from 'shared/constants';
import { getSSRExperimentVariant } from '@nykaa/experiment-sdk/store/selectors';
import { getExperimentVariant } from '@nykaa/experiment-sdk/client';

// helpers
import { isDateValid } from 'shared/helpers/utils';

// constants
import {
  GAMIFICATION_NUDGE,
  GAMIFICATION_NUDGE_VARIANT_A,
} from 'shared/components/GamificationNudge/constants';

const mapStateToProps = (state: any, ownProps: any) => {
  const {
    color,
    type,
    isOutOfStock,
    imageUrl,
    categoryName = '',
    price_reveal_data = {},
    fomo_tag = {},
    sale_price_live_flag = false,
  } = getProductData(state);
  const { isMobile } = ownProps;
  const isPriceReveal = get(
    getRemoteConfig(state, `priceReveal`),
    isMobile ? 'mobile' : 'desktop',
    false
  )
    ? !!price_reveal_data?.sp
    : undefined;

  const isSalePriceLiveEnabled = get(
    getRemoteConfig(state, `priceReveal`).salePromotionConfig,
    isMobile ? 'mobile' : 'desktop',
    false
  );
  const isSalePriceLive = isSalePriceLiveEnabled && sale_price_live_flag;

  const isFomoTimerVisible = get(getRemoteConfig(state, 'fomoTimer'), 'pdp.enable', false)
    ? isDateValid(fomo_tag?.end_time)
    : undefined;

  const { isEligible: isGamificationNudgeEnabled = false, variant } =
    getExperimentVariant(GAMIFICATION_NUDGE);

  return {
    productID: getProductId(state),
    title: getProductTitle(state),
    subTitle: getProductSubTitle(state),
    sizeOptions: getProductSizeOptions(state),
    parentSKU: getProductParentSKU(state),
    isOneSize: isOneSize(state),
    price: getProductPrice(state),
    discountedPrice: getProductDiscountPrice(state),
    tags: getTagTitles(state),
    review: getReviewSummary(state),
    isSizeGuideAvailable: getSizeGuideURL(state),
    colorOptions: getColorOptions(state),
    defaultColor: getDefaultColor(state),
    isVideoAvailable: isVideoAvailableOnPDP(state),
    disclaimerText: getDisclaimerText(state),
    areResponsibleTagsAvailable: getReponsibleTagsAvailable(state),
    colorConfig: color?.name || '',
    type,
    isOutOfStock,
    imageUrl,
    deliveryDetails: getDeliveryDetails(state),
    isProductReturnable: _isReturnable(state),
    categoryName,
    isPriceReveal,
    currency: DEFAULT_CURRENCY_CODE,
    discountPercentage: getProductDiscount(state),
    categoryLevels: getCategoryLevel(state),
    selectedSizeName: getSelectedSizeName(state),
    selectedSKUID: getSelectedSKUID(state),
    productBadge: getBadge(state)?.title,
    urgencyNudgeData: getUrgencyNudge(state),
    urgencyNudgeEnabled: get(
      getRemoteConfig(state, 'urgencyNudge'),
      isMobile ? 'pdp.mweb' : 'pdp.dweb',
      {
        mweb: false,
        dweb: false,
        textColor: '',
      }
    ),
    isFomoTimerVisible,
    isSalePriceLive,
    isViewSimilarAvailable: hasViewSimilar(state),
    pdpSections: getSelectedSKUDataPDPSections(state),
    isAplusContentAvailable: !isEmpty(getHeroImageData(state)),
    isModelDetailsAvailable: !isEmpty(getModelWidgetData(state)),
    isNewSizeChartEnabled: get(
      getSSRExperimentVariant(state, 'new-size-chart'),
      'isEligible',
      false
    ),
    isSizeChartDataAvailable: getIsSizeGuideDataAvailable(state),
    isBrandBookEnabled: getRemoteConfig(state, 'showBrandBookEnabled'),
    isBrandBookData: getBrandBook(state),
    isGamificationEnabled: isGamificationNudgeEnabled,
    isGamificationAggresive:
      isGamificationNudgeEnabled && variant === GAMIFICATION_NUDGE_VARIANT_A ? 0 : 1,
  };
};

export default connect(mapStateToProps)(Analytics);
